var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1764068477162,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 18790,
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M844.920471 125.289412a30.117647 30.117647 0 0 1 30.117647 30.117647l0.060235 271.058823a30.117647 30.117647 0 0 1-30.117647 30.117647h-722.82353a30.117647 30.117647 0 0 1-30.117647-30.117647v-271.058823a30.117647 30.117647 0 0 1 30.117647-30.117647h722.82353z m-30.117647 60.235294h-662.588236l0.060236 210.823529h662.588235v-210.823529z m-391.529412 75.294118v60.235294h-180.705883v-60.235294h180.705883z m421.707294 256a30.117647 30.117647 0 0 1 30.117647 30.117647v271.058823a30.117647 30.117647 0 0 1-30.117647 30.117647h-722.82353a30.117647 30.117647 0 0 1-30.117647-30.117647v-271.058823a30.117647 30.117647 0 0 1 30.117647-30.117647h722.82353z m-30.117647 60.235294h-662.588235v210.823529h662.588235v-210.823529z m-391.529412 75.294117v60.235294h-180.705882v-60.235294h180.705882z",
    fill: "#8a8a8a",
    fillOpacity: 0.81,
    "p-id": 18791
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg48);
export default __webpack_public_path__ + "static/media/直连设备48.c9746a7390f9ec2cb2618b6072262709.svg";
export { ForwardRef as ReactComponent };